import { api } from './api';

export type SignalKind =
  | 'job_change'
  | 'funding'
  | 'hiring_spike'
  | 'tech_install'
  | 'press'
  | 'tdnet'
  | 'edinet'
  | 'exec_announcement';

export interface Signal {
  id: string;
  workspaceId: string;
  kind: SignalKind;
  accountId: string | null;
  contactId: string | null;
  occurredAt: string;
  source: string;
  sourceUrl: string | null;
  payload: Record<string, unknown>;
  score: number | null;
  status: 'new' | 'read' | 'acted' | 'dismissed';
  createdAt: string;
}

export const signalsApi = {
  list: async (params: {
    workspaceId: string;
    kind?: SignalKind;
    status?: Signal['status'];
    accountId?: string;
    contactId?: string;
    limit?: number;
    offset?: number;
  }) => {
    const r = await api.get<{ items: Signal[]; total: number }>('/api/signals', { params });
    return r.data;
  },
  markStatus: async (id: string, status: Signal['status']) => {
    const r = await api.patch<Signal>(`/api/signals/${id}/status`, { status });
    return r.data;
  },
  ingestStub: async (workspaceId: string) => {
    const r = await api.post<{ inserted: number }>('/api/signals/ingest-stub', { workspaceId });
    return r.data;
  },
  remove: async (id: string): Promise<void> => {
    await api.delete(`/api/signals/${id}`);
  },
};
